import { ColDef } from "@ag-grid-community/all-modules";
import LastUpdated from "common/ui/LastUpdated";
import DeliveryPeriod, { CommoditySettings } from "domain/deliveryPeriod";
import _ from "lodash";
import React from "react";
import { BidTable } from "./BidTable";
import BidTableHeader from "./BidTableHeader";
import BidTableProps from "./bidTableProps";
import PhysicalLocation from "domain/physicalLocation";
import Commodity from "domain/commodity";
import useColumnDefinitions from "common/agGrid/useColumnDefinitions";

function getLastUpdatedDate(deliveryPeriods: DeliveryPeriod[]): Date {
    if (deliveryPeriods == null) return null;
    return _.max(deliveryPeriods.filter(m => m.contract != null).map(x => x.contract.priceUpdated))
}

const SingleCommodityBidTable: React.FC<BidTableProps> = (props) => {
    if (props.locations == null || props.locations.length === 0) return <></>;
    
    return <div className="container-fluid single-locations-wrapper">
        <div className="row col-12">
            {props.commodities.map(c => <TableForCommodity key={c.id}
                commodity={c}
                deliveryPeriods={props.periodsByCommodity[c.id]}
                getColumnDefinitions={() => props.getColumnDefinitions(c, false)}
                locations={props.locations}
                selectedCommoditySettings={props.selectedCommoditySettings}
                hideLocationsButton
                saveCommoditySettingsChanges={props.saveCommoditySettingsChanges}
                isCustomer={props.isCustomer}
            />)}
        </div>
    </div>;
}

interface TableForCommodityProps {
    commodity: Commodity;
    deliveryPeriods: DeliveryPeriod[];
    locations: PhysicalLocation[];
    selectedCommoditySettings: CommoditySettings[];
    saveCommoditySettingsChanges(commoditySettings: CommoditySettings[]): any;
    hideLocationsButton: boolean;
    isCustomer: boolean;
    getColumnDefinitions(): ColDef[];
}

const TableForCommodity: React.FC<TableForCommodityProps> = props => {
    const columns = useColumnDefinitions(props.getColumnDefinitions, [props.commodity, props.locations, props.getColumnDefinitions]);

    return <div className="single-location-container">
        <BidTableHeader commodity={props.commodity}
            locations={props.locations}
            selectedCommoditySettings={props.selectedCommoditySettings}
            hideLocationsButton
            saveCommoditySettingsChanges={props.saveCommoditySettingsChanges}
            isCustomer={props.isCustomer}>
            <span className="pr-1">
                {props.commodity.displayName}
            </span>
            <LastUpdated lastUpdated={getLastUpdatedDate(props.deliveryPeriods)} label="Prices as of"  />
        </BidTableHeader>
        <div className="row">
            <BidTable
                deliveryPeriods={props.deliveryPeriods}
                columnDefinitions={columns} />
        </div>
    </div>;
}

export default SingleCommodityBidTable;